import { useState } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Settings2 } from 'lucide-react';
import { useSettings } from '@/contexts/SettingsContext';
import EditContextsDialog from './EditContextsDialog';

export default function ContextSelector({ 
  showEditButton = true,
  showShowAll = false,
  className = '',
  triggerClassName = '',
  contentClassName = '',
  viewportClassName = '',
  align = 'start'
}) {
  const { 
    contexts, 
    selectedContextId, 
    setSelectedContextId,
    contextsEnabled,
    fetchContexts
  } = useSettings();
  
  const [showEditDialog, setShowEditDialog] = useState(false);

  if (!contextsEnabled || contexts.length === 0) {
    return null;
  }

  const selectedContext = contexts.find(c => c.id === selectedContextId);

  const handleContextChange = (value) => {
    if (value === 'edit') {
      setShowEditDialog(true);
    } else {
      setSelectedContextId(value === 'show-all' ? null : value);
    }
  };

  return (
    <>
      <div className={`flex items-center gap-2 ${className}`}>
        <Select 
          value={selectedContextId || (showShowAll ? 'show-all' : contexts[0]?.id)} 
          onValueChange={handleContextChange}
        >
          <SelectTrigger className={`w-auto min-w-fit max-w-[180px] ${triggerClassName}`} data-testid="context-selector">
            <SelectValue placeholder="Select context" />
          </SelectTrigger>
          <SelectContent className={contentClassName} viewportClassName={viewportClassName} align={align}>
            {showShowAll && (
              <SelectItem value="show-all">Show All</SelectItem>
            )}
            {contexts.map((context) => (
              <SelectItem key={context.id} value={context.id}>
                {context.name}
              </SelectItem>
            ))}
            {showEditButton && (
              <>
                <div className="border-t my-1" />
                <SelectItem value="edit" className="text-muted-foreground">
                  <span className="flex items-center gap-2">
                    <Settings2 size={14} />
                    Edit Contexts
                  </span>
                </SelectItem>
              </>
            )}
          </SelectContent>
        </Select>
      </div>

      <EditContextsDialog 
        open={showEditDialog} 
        onOpenChange={setShowEditDialog}
        onContextsChanged={fetchContexts}
      />
    </>
  );
}
